export default __webpack_public_path__ + "static/media/linkedin.9f63f9d9.svg";